module.exports = __webpack_public_path__ + "img/ico-paylink.5c7f2b1a.svg";